import { render, staticRenderFns } from "./Constrain.vue?vue&type=template&id=40c89148"
import script from "./Constrain.vue?vue&type=script&lang=ts"
export * from "./Constrain.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports